<template>
  <section>
    <div class="title">
      <h1>Let people pay for tickets how they want</h1>

      <p>
        HelixPay Ticketing Technology comes with all popular payment methods in
        the Philippines
      </p>
    </div>

    <div class="clients">
      <div class="first">
        <div class="details">
          <img src="/img/gcash-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/maya.svg" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-711-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-cebuana-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-palawan-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/gcash-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/maya.svg" alt="" />
        </div>
        <div class="details">
          <img id="bigIcons" src="img/ticketing-711-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-cebuana-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-palawan-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/gcash-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/maya.svg" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-711-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-cebuana-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-palawan-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/gcash-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/maya.svg" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-711-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-cebuana-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-palawan-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/gcash-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/maya.svg" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-711-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-cebuana-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-palawan-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/gcash-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/maya.svg" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-711-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-cebuana-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="img/ticketing-palawan-icon.png" alt="" />
        </div>
      </div>

      <div class="second">
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-ub-icon.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/grabpay.png" alt="" />
        </div>
        <div class="details">
          <img src="/img/visa.svg" alt="" />
        </div>
        <div class="details">
          <img src="/img/ticketing-bpi-icon.png" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
span {
  opacity: 0.5;
}

section {
  width: 100%;
}

.clients {
  width: 100%;
  margin: 5rem auto;
  padding: 1rem 0;
  display: grid;
  grid-auto-columns: 1fr;
  gap: 2rem;
  overflow: hidden;
}

.title {
  padding: 4rem 2rem 0 2rem;
  max-width: 71rem;
  margin: auto;
}

.title h1 {
  text-align: center;
  font-size: 3rem;
  font-weight: 700;
  margin: 0;
  margin-bottom: 1rem;
}

.title p {
  text-align: center;
  font-weight: 600;
  margin-top: 1rem;
  font-size: 1.3rem;
  opacity: 0.5;
  margin: 0;
}

.details {
  width: 20rem;
  display: grid;
  justify-content: center;
  align-items: center;
  transform: scale(1);
  transition: 0.2s ease-in;
  gap: 1rem;
  color: white;
  padding: 1rem;
  border-radius: 10px;
  background-color: black;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.details img {
  width: 70%;
  margin: auto;
  padding: 1rem;
}

.details p {
  display: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ FIRST */

.first {
  display: grid;
  grid-template-columns: repeat(30, 1fr);
  gap: 2rem;
  margin: auto;
  animation: left 2000s infinite;
}

@keyframes left {
  0% {
    transform: translateX(-450rem);
  }
  100% {
    transform: translateX(0rem);
  }
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SECOND */

.second {
  display: grid;
  grid-template-columns: repeat(30, 1fr);
  gap: 2rem;
  margin: auto;
  animation: right 2000s infinite;
}

@keyframes right {
  0% {
    transform: translateX(0rem);
  }
  100% {
    transform: translateX(-450rem);
  }
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SECOND */

.third {
  display: grid;
  grid-template-columns: repeat(30, 1fr);
  gap: 2rem;
  margin: auto;
  animation: left 2000s infinite;
}

@media only screen and (max-width: 750px) {
  .clients {
    gap: 1rem;
  }

  .first {
    gap: 1rem;
  }

  .details {
    width: 8rem;
    grid-template-columns: 1fr;
  }

  .details img {
    width: 100%;
    margin: auto;
    padding: 0.5rem;
  }

  @keyframes left {
    0% {
      transform: translateX(-220rem);
    }
    100% {
      transform: translateX(0rem);
    }
  }
}

@media only screen and (max-width: 650px) {
  .title h1 {
    font-size: 2rem;
  }
}
</style>
